import app from "@/main";
import {MtsTarafTebligatCevapRow} from "../../../uyap/MtsTarafTebligatList";
import {AbstractTaskHandler} from "./AbstractTaskHandler";
import {ITask} from "../GorevYoneticisiTypes";
import {TaskDurum} from "../../../enum/TaskDurum";
import {OdemeTipiEnum} from "@/plugins/uyap-plugin/takip_ac/OdemeTipleri";


export class MtsTebligatGonderTaskResponse {
    message: string = "";
    dosyaEsasNo: string = "";
    taraflar: any[] = [];
    tebligatUcreti: number = 0;
    // tebligatlar: Blob[] = []; şuan bir işe yaramıyor. tebligatlar istenirse cdne kaydedip bilgilerini tutmak lazım,
    barkodlar: string[] = [];
}

export class MtsTebligatGonderTaskHandler extends AbstractTaskHandler {
    async handle(task: ITask): Promise<ITask> {
        try {
            let data: {
                adresTuru: string,
                dosya: {
                    dosyaNo: string,
                    dosyaId: string,
                    taraflar: any[],
                }
            } = task.data;
            let response: MtsTebligatGonderTaskResponse = new MtsTebligatGonderTaskResponse();
            response.dosyaEsasNo = data.dosya.dosyaNo;
            response.taraflar = data.dosya.taraflar;
            let tebligatList = await app.$uyap.MtsTarafTebligatList().run({
                dosyaId: data.dosya.dosyaId
            })

            let MTSTebligat = 1;
            let tebligatKisiKurumIdList: any[] = [];
            tebligatList.forEach((tebligatDvo: MtsTarafTebligatCevapRow) => {
                tebligatKisiKurumIdList.push(tebligatDvo.tarafTebligatDVO.evrakKisiDVO.guncelKisiKurumId);
            })

            response.tebligatUcreti = await app.$uyap.MtsTebligatUcreti().run({
                dosyaId: data.dosya.dosyaId,
                tebligatKisiKurumIdList: JSON.stringify(tebligatKisiKurumIdList)
            })

            let tebligatlar = await app.$uyap.MtsTebligatGonder().run({
                MTSTebligat: MTSTebligat,
                dosyaId: data.dosya.dosyaId,
                tebligatKisiKurumIdList: JSON.stringify(tebligatKisiKurumIdList),
                tebligatUcreti: response.tebligatUcreti,
                odemeTipi: OdemeTipiEnum.Ebarobirlikkart
            });

            tebligatlar.forEach(tebligat => {
                response.barkodlar.push(tebligat.tarafTebligatDVO.tebligatInputDVO.inputDVO.barkodNo);
            })

            /*
            kullanıcı tebligatlarını da ister ise aç
            for (const tebligat of tebligatlar) {
                let evrakBlob = await app.$uyap.EvrakIndir().run({
                    evrakId: tebligat.evrakId,
                    dosyaId: data.dosya.dosyaId,
                    yargiTuru: ''
                });
                response.tebligatlar.push(evrakBlob);
            }
            cdn'e kaydolmuyor dikkat et
            */
            response.message = "Tebligat Gönderildi";
            task.response = response;
            task.status = TaskDurum.BITTI_BASARILI;
            return task;
        } catch (e) {
            throw new Error(e.message);
        }
    }
}